export const iconFontAwesomeMedicalHealthStarOfLife = (
	<i className="fa-solid fa-star-of-life"></i>
);
